import {AssemblyModel} from "./AssemblyModel";

export enum RobotSlot {
    Head = "head",
    Body = "body",
    LeftArm = "larm",
    RightArm = "rarm",
    LeftLeg = "lleg",
    RightLeg = "rleg",
}

export const RobotSlots = [
    RobotSlot.Head,
    RobotSlot.Body,
    RobotSlot.LeftArm,
    RobotSlot.RightArm,
    RobotSlot.LeftLeg,
    RobotSlot.RightLeg,
];

export type RobotModel = AssemblyModel<RobotSlot>;